"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fuerosStore = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createSuper"));

var _FuerosApi = require("@/api/FuerosApi");

var _NotifyUtils = require("@/utils/NotifyUtils");

var _index = require("./index");

var _LoaderStore = require("./LoaderStore");

var FuerosStore = /*#__PURE__*/function (_Store) {
  (0, _inherits2.default)(FuerosStore, _Store);

  var _super = (0, _createSuper2.default)(FuerosStore);

  function FuerosStore() {
    (0, _classCallCheck2.default)(this, FuerosStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FuerosStore, [{
    key: "data",
    value: function data() {
      return [];
    }
  }, {
    key: "loadData",
    value: function () {
      var _loadData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.getState().length === 0)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.loadFueros();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }, {
    key: "loadFueros",
    value: function () {
      var _loadFueros = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _LoaderStore.loaderStore.setLoader({
                  loading: true
                });

                _context2.prev = 1;
                _context2.t0 = this;
                _context2.next = 5;
                return (0, _FuerosApi.getData)();

              case 5:
                _context2.t1 = _context2.sent;

                _context2.t0.setState.call(_context2.t0, _context2.t1);

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t2 = _context2["catch"](1);
                (0, _NotifyUtils.notifyError)(_context2.t2);

              case 12:
                _context2.prev = 12;

                _LoaderStore.loaderStore.setLoader({
                  loading: false
                });

                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9, 12, 15]]);
      }));

      function loadFueros() {
        return _loadFueros.apply(this, arguments);
      }

      return loadFueros;
    }()
  }]);
  return FuerosStore;
}(_index.Store);

var fuerosStore = new FuerosStore();
exports.fuerosStore = fuerosStore;